import { Box } from "@mui/material";
import * as React from "react";
import Grid from "@mui/material/Grid";
interface PropType {}
interface StateType {
  loadState: String;
}

class LytAboutPage extends React.Component<PropType, StateType> {
  state = {
    loadState: "loading",
  };

  htmlData?: string;

  componentDidMount = () => {};

  render() {
    return (
      <Box id="lytAboutPageWrapper">
        <Grid container sx={{ justifyContent: "center" }}>
          <Grid size={{ xs: 8, md: 4 }}>
            <img
              alt="Haru Tai"
              src="./Images/about/Haru Tai.jpg"
              className="aboutimg"
            />
          </Grid>
          <Grid size={{ xs: 10, md: 6 }}>
            <div className="aboutText">
              <p>
                Hi! I'm Haru Tai, an Illustrator based in Toronto. I've loved
                art from the moment I could hold a pencil, proudly saying I
                would become an artist when I grew up. I'm passionate about
                creating bold visuals with bright colours while tying a theme or
                story into my work. I love working with all subject matter, from
                cute to creepy. I primarily work digitally, although I am open
                to experimenting more with analogue. I love making characters,
                drawing tattoo flash, and red and black colours.
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default LytAboutPage;
